export const tr = {
    'add-success': 'Ürün eklendi',
    error: 'Hata oluştu, daha sonra tekrar deneyin'
};
